const COOKIEBOT_ID = "442049e2-9572-46b9-9a42-593a1ba85592";

// Only initialize in production
const isProduction = process.env.NODE_ENV === "production";

export const initCookiebot = () => {
	if (!isProduction) return;

	const script = document.createElement("script");
	script.id = "Cookiebot";
	script.src = "https://consent.cookiebot.com/uc.js";
	script.setAttribute("data-cbid", COOKIEBOT_ID);
	script.setAttribute("data-blockingmode", "auto");
	script.type = "text/javascript";

	// Insert as first script in head
	const firstScript = document.head.getElementsByTagName("script")[0];
	if (firstScript) {
		document.head.insertBefore(script, firstScript);
	} else {
		document.head.appendChild(script);
	}
};
